import {
  IPartnerStatusIcon,
  IPartnerStatusLabel,
  TPartnerStatus,
} from 'legacy/lut/features/partner360/configuration/models/IPartnerStatus'

export const isPartnerStatusIcon = (v: TPartnerStatus): v is IPartnerStatusIcon => {
  return Object.hasOwnProperty.call(v, 'Icon')
}

export const isPartnerStatusLabel = (v: TPartnerStatus): v is IPartnerStatusLabel => {
  return Object.hasOwnProperty.call(v, 'Title')
}
